export default "__VITE_PUBLIC_ASSET__22b9bb79__"